import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const MetricVisibilityToggle = () => {
    const { showHeatmapHover, setShowHeatmapHover } = usePlacementStore(
        useShallow((state) => ({
            showHeatmapHover: state.showHeatmapHover,
            setShowHeatmapHover: state.setShowHeatmapHover
        }))
    );

    return (
        <div className="flex shrink-0 items-center justify-center px-1 sm:px-1">
            <Tooltip
                label={showHeatmapHover ? 'Hide hover metrics' : 'Show hover metrics'}
                position="bottom"
                variant={variants.tooltip.bottom}
            >
                <ActionIcon
                    aria-label={showHeatmapHover ? 'Hide hover metrics' : 'Show hover metrics'}
                    className="bg-background-transparent hover:bg-background-gray! pointer-events-auto action-icon-medium"
                    variant={showHeatmapHover ? variants.actionIcon.activated : undefined}
                    onPointerDown={() => setShowHeatmapHover(!showHeatmapHover)}
                >
                    info
                </ActionIcon>
            </Tooltip>
        </div>
    );
};
